import { admStatsByCustomer } from "@/graphql/schemas/revenue/utils/admStatsByCustomer"
import { checkPermissions } from "@/graphql/schemas/shared/permissions/permissions"
import { DomainObjects, Operations } from "@/graphql/schemas/shared/permissions/permissionsConfig"

export const queryAdmStatsByCustomer = {
  async admStatsByCustomer(parent, args, context) {
    const { year = new Date().getFullYear(), admNumber, page = 0, size = 5, sort, lastYearData = false } = args

    const user = context?.user

    await checkPermissions({
      user,
      domainObject: DomainObjects.REVENUES,
      operation: Operations.READ,
    })

    const { admStats } = await admStatsByCustomer({
      admNumber,
      year,
      page,
      size,
      sort,
      lastYearData,
    })

    if (!admStats) {
      return {
        items: [],
        page: 0,
        numberOfElements: 0,
        totalElements: 0,
        totalPages: 0,
      }
    }

    return {
      items: admStats?.content,
      page: page,
      numberOfElements: admStats?.numberOfElements,
      totalElements: admStats?.totalElements,
      totalPages: admStats?.totalPages,
    }
  },
}
